import { createAsyncThunk } from '@reduxjs/toolkit';
import jobApi from '~/apis/job';
import { GET_JOBS } from '~/utils/constants/actionType';
import { IParamsGetJobs, IResponseGetJob } from '~/utils/interface/job';

export const handleGetJobs = createAsyncThunk<IResponseGetJob, IParamsGetJobs>(
  GET_JOBS,
  async (params: IParamsGetJobs = {}, { rejectWithValue }) => {
    try {
      const res = await jobApi.getJobs(params);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

